import HTTPService from '../HTTPService'

class Stream {
  fetch (companySlug, clientId, cursor = null) {
    return HTTPService.get(`company/${companySlug}/client/${clientId}/stream?mark_as_read=1${cursor ? `&cursor=${cursor}` : ''}`)
  }
}

export default new Stream()
